export const validateTeamForm = (
  groupId: string | number | null,
  comment: string,
  description: string
): string[] => {
  const errors: string[] = [];

  if (!groupId || groupId === 0) {
    errors.push("Please select picklist group");
  }

  const descriptionRegex = /^[a-zA-Z0-9\s]*$/;
  if (!description.trim()) {
    errors.push("Description is mandatory");
  } else if (description.length > 100) {
    errors.push("Description should not exceed 100 characters");
  }
  if (!comment.trim()) {
    errors.push("Comments is mandatory");
  } else if (comment.length > 100) {
    errors.push("Comments should not exceed 100 characters");
  }

  return errors;
};

let isAddButtonToggle = true; // Default value

type Row = {
  id: number;
  Picklistitemid: number;
  itemName: string;
  displayName: string;
  description: string;
  comments: string;
  sortSequence: any;
  isActive: boolean; // or number if needed
  isEditing: boolean;
  originalData?: Row; // Store the original data for reverting edits
  isNew?: boolean; // Indicates whether the row is a new row
  createdBy?: number;
  createdDate?: string;
  modifiedBy?: number;
  modifiedDate?: string;
  createdbyName?: string;
  createddate?: string;
  modifiedbyName?: string;
  modifieddate?: string;
};
export const validatePicklistItem = (
  itemName: string,
  displayName: string,
  description: string,
  comments: string,
  sortSequence: string,
  isActive: boolean,

  existingRows: Row[]
): string[] => {
  const errors: string[] = [];
  //const alphanumericWithSymbolsRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;
  const alphanumericWithSpacesRegex = /^[a-zA-Z0-9\s,._\-!@#$%^&*()+=]*$/;

  if (!itemName.trim()) {
    errors.push("Item Name is mandatory.");
  } else if (!alphanumericWithSpacesRegex.test(itemName)) {
    errors.push(
      "Item Name can only contain alphanumeric characters and spaces."
    );
  } else if (
    existingRows.some(
      (row) =>
        row.itemName.trim().toLowerCase() === itemName.trim().toLowerCase()
    )
  ) {
    errors.push("Item Name must be unique.");
  }

  if (!displayName.trim()) {
    errors.push("Display Name is mandatory.");
  } else if (!alphanumericWithSpacesRegex.test(displayName)) {
    errors.push(
      "Display Name can only contain alphanumeric characters and spaces."
    );
  } else if (
    existingRows.some(
      (row) =>
        row.displayName.trim().toLowerCase() ===
        displayName.trim().toLowerCase()
    )
  ) {
    errors.push("Display Name must be unique.");
  }

  if (description.trim() && !alphanumericWithSpacesRegex.test(description)) {
    errors.push(
      "Description can only contain alphanumeric characters and spaces."
    );
  }

  if (comments.trim() && !alphanumericWithSpacesRegex.test(comments)) {
    errors.push(
      "Comments can only contain alphanumeric characters and spaces."
    );
  }

  if (!sortSequence.trim()) {
    errors.push("Sort Sequence is mandatory.");
  } else if (!/^\d+$/.test(sortSequence)) {
    errors.push("Sort Sequence must be a number.");
  } else {
    const sortSequenceNumber = Number(sortSequence);

    // **Check uniqueness only among active rows**
    const isDuplicateActiveSort = existingRows.some(
      (row) => Number(row.sortSequence) === sortSequenceNumber && row.isActive
    );

    // Only enforce uniqueness if the new row is active
    if (isActive && isDuplicateActiveSort) {
      errors.push("Sort Sequence must be unique among active items.");
    }
  }
  return errors;
};
